function wfuSetCookie(sCookieName, sCookieValue, iDaysToExpiration) {
    var d = new Date();
    d.setTime(d.getTime() + (iDaysToExpiration*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = sCookieName + "=" + sCookieValue + ";" + expires + ";path=/;domain=wfu.edu;";
}

function wfuGetCookie(sCookieName) {
    var sName = sCookieName + "=";
    var sDecodedCookie = decodeURIComponent(document.cookie);
    var aCookies = sDecodedCookie.split(';');
    for (var i = 0; i <aCookies.length; i++) {
        var cookie = aCookies[i];
        while (cookie.charAt(0) == ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(sName) == 0) {
            return cookie.substring(sName.length, cookie.length);
        }
    }
    return "";
}

function wfuHandleAudienceCookie() {
    sAudienceCookie = wfuGetCookie('wfu_audience_segment');

    if (sAudienceCookie != "") {
        oStudentMegaButtons = $('.student-mega .menu-controls ul li');
        oStudentMegaMenus = $('.student-mega .menu-row');
        oStudentMegaButtons.removeClass('active');
        oStudentMegaMenus.children().removeClass('active');
        oStudentMegaButtons.each(function() {
            if ($(this).data('target') == sAudienceCookie) {
                $(this).addClass('active');
            }
        });
        oStudentMegaMenus.children().each(function() {
            if ($(this).data('menu') == sAudienceCookie) {
                $(this).addClass('active');
            }
        });
    }
}

function hide_spotlight_lists(iViewPortWidth) {
    if (iViewPortWidth >= 1024) {
        $('.student_spotlight_list').hide();
    }
}

function process_headers() {
    var iDeptHeaderHeight = $('#sitenav').height();
    var iGlobalHeaderHeight = $('.heater_container').height();
    var iWordPressHeaderHeight = $('#wpadminbar').height();
    var iCombinedHeaderHeight = iDeptHeaderHeight + iGlobalHeaderHeight;
    var oHeaderHeights = {'combined':iCombinedHeaderHeight, 'global': iGlobalHeaderHeight, 'dept':iDeptHeaderHeight, 'wp': iWordPressHeaderHeight};

    return oHeaderHeights;
}

function handle_alert_bar() {
    var oAlertInner = $('#wake-alert div');
    var oAlertContainer = $('#wake-alert');
    var iInnerHeight = oAlertInner.height();
    var oOpenMegaMenu = $('.heater_container .mega-menu');
    var oNavItems = $('.nav_items');
    if (iInnerHeight !== null) {
        oAlertContainer.css('height', iInnerHeight);
        if ($('#player').length > 0) {
            $('#player').css('margin-top', iInnerHeight);
        }
        if ($(window).width() > 1025) {
            oOpenMegaMenu.css('margin-top', iInnerHeight);
        }
        if ($(window).width() >= 1024) {
            oNavItems.css('top', 'initial');
        } else {
            oNavItems.css('top', iInnerHeight + 100);
        }
    }
}

function fix_wp_caption_width() {
    oWPCaption = $('.wp-caption');
    iWidth = oWPCaption.width();
    oWPCaption.attr('style','');
    oWPCaption.css('max-width', iWidth+'px');
}

$(document).ready(function() {
    $(document).foundation();
    if (typeof addthis != 'undefined') {
        addthis.init();
    }
    var bOrientationChange = false;
    var $window = $(window);
    var iScrollTopAny = 0;
    var iViewPortWidth = $window.width();
    var iViewPortHeight = $window.height();
    var iVerticalScrollPos = 0;
    var oBody = $('body');
    var oHeader = $('#header');
    var oSiteNav = $('#sitenav');
    var iGlobalHeaderHeight = $('.heater_container').height();

    $('#search-form').on('submit', function(e){
        e.preventDefault();
        $('#google_search-header').val($("#search-header").val());
        $('#search-form')[0].submit();
    });

    setTimeout(function() {
        handle_alert_bar();
    }, 1000);

    if (iViewPortWidth < 1024) {
        $('#sitenav').addClass('dept_menu_closed');
        $('#sitenav').removeClass('dept_menu_expanded');
    } else {
        $('#sitenav').removeClass('dept_menu_closed');
        $('#sitenav').addClass('dept_menu_expanded');
    }
    wfuHandleAudienceCookie();
    //Set audience cookie on click
    $('.student-mega ul li button').click(function() {
        sDataTarget = $(this).parent('li').data('target');
        wfuSetCookie('wfu_audience_segment', sDataTarget, 180);
    });
    //Overview Links for Dept header

    $('#sitenav .nav_items_section .has_overview ul.is_dropdown').each(function() {
        sOverviewLink = $(this).siblings('a').attr('href');
        var bNoOverview = $(this).parent().hasClass('no_overview');
        if (bNoOverview === false) {
            $(this).prepend('<li class="page_item"><a href="'+sOverviewLink+'">Overview</a></li>');
            $(this).siblings('a').attr('href', '#');
        }
    });

    //Dept Nav
    $window.on('resize', function() {

        handle_alert_bar();
        var iNewViewPortWidth = $window.width();
        var iNewViewPortHeight = $window.height();

        bOrientationChange = did_orientation_change(iViewPortWidth, iViewPortHeight, iNewViewPortWidth, iNewViewPortHeight);

        hide_spotlight_lists(iNewViewPortWidth);
        if (bOrientationChange === true) {
            if (iNewViewPortWidth < 1024) {
                $('#sitenav').addClass('dept_menu_closed');
                $('#sitenav').removeClass('dept_menu_expanded');
            }
        }
        if (iNewViewPortWidth >= 1024) {
            $('#sitenav').removeClass('dept_menu_closed');
            $('#sitenav').addClass('dept_menu_expanded');
        }
        iViewPortWidth = $window.width();
        iViewPortHeight = $window.height();
    });

    $('#sitenav ul.dept_menu_burger').click(function() {
        if ($('#sitenav').hasClass('dept_menu_expanded') == true) {
            $('#sitenav').removeClass('dept_menu_expanded');
            $('#sitenav').addClass('dept_menu_closed');
        } else {
            $('#sitenav').removeClass('dept_menu_closed');
            $('#sitenav').addClass('dept_menu_expanded');
        }
    });

    $('#sitenav .nav_items_section li.has_dropdown').click(function(e) {
        if ($(this).attr('href') === '#') {
            e.preventDefault();
        }
        if ($(this).parent('ul').hasClass('is_dropdown') == false) {
            window.scrollTo(0, iVerticalScrollPos);
        }
        if ($(this).hasClass('dropdown_open') === true) {
            $(this).removeClass('dropdown_open');
        } else if ($(this).hasClass('dropdown_open') === false) {
            $('#sitenav .nav_items_section li.has_dropdown').removeClass('dropdown_open');
            $(this).addClass('dropdown_open');
        }
    });

    $('#sitenav .nav_items_section li.has_dropdown ul.is_dropdown').focusout(function(e) {
        if ($(this).parent().hasClass('dropdown_open') === true) {
            $(this).parent().removeClass('dropdown_open');
        }
    });

    $('#sitenav .nav_items_section li.has_dropdown ul.is_dropdown').focusin(function(e) {
        if ($(this).parent().hasClass('dropdown_open') === false) {
            $('#sitenav .nav_items_section li.has_dropdown').removeClass('dropdown_open');
            $(this).parent().addClass('dropdown_open');
        }
    });

    $('.root-menu-title span').click(function() {
        $('ul.more_user_button').removeClass('user_button_active');
        if ($(this).parent().hasClass('active') == true) {
            $(this).parent().siblings('.more_user_button_container').children('ul.more_user_button').removeClass('user_button_active');
        } else {
            $(this).parent().siblings('.more_user_button_container').children('ul.more_user_button').addClass('user_button_active');
        }
    });

    fix_wp_caption_width();


    $('.clearing-main-prev').each(function(index, value) {
        $(this).attr('aria-label', 'Previous');
    });
    $('.clearing-main-next').each(function(index, value) {
        $(this).attr('aria-label', 'Next');
    });

    $('.click_toggle').click(function () {
        var $sElementClickNumber = $(this).data('click-toggle-number');
        var $sClickToggleState = $(this).data('click-toggle-state');
        var $oElementToToggle = $('#click_toggle_'+$sElementClickNumber);
        var $sMaxHeight = $(this).data('click-toggle-max-height');
        var $sClosedText = $(this).data('click-toggle-closed-text');
        var $sOpenText = $(this).data('click-toggle-open-text');

        if ($sClickToggleState === 'closed') {
            $oElementToToggle.animate(
                {opacity: '1.0', height: $sMaxHeight},
                600,
                'swing'
            );
            $(this).data('click-toggle-state', 'open');
            $(this).html($sClosedText);
        } else {
            $oElementToToggle.animate(
                {opacity: '0', height: '0px'},
                600,
                'swing'
            );
            $(this).data('click-toggle-state', 'closed');
            $(this).html($sOpenText);
        }
    });
    function did_orientation_change(iOldWidth, iOldHeight, iNewWidth, iNewHeight) {
        var iOldRatio = (iOldWidth / iOldHeight);
        var iNewRatio = (iNewWidth / iNewHeight);
        if ((iOldRatio <= 1 && iNewRatio <= 1) || (iOldRatio >= 1 && iNewRatio >= 1)) {
            return false;
        } else {
            return true;
        }
    }

    function download_file(sUrl, sFileName) {
        console.log('hit top of download file function');
        console.log('the window.download is '+window.download);
        console.log('the sUrl is '+sUrl);
        if(window.download && sUrl) {
            console.log('hit top of download file function');
            sFileName = sFileName || sUrl.split('/').pop().split('?')[0];
            console.log('the file name is '+sFileName);
            var ajax = new XMLHttpRequest();
            ajax.open( 'GET', sUrl, true);
            ajax.responseType = 'blob';
            ajax.onload= function(e){
                download(e.target.response, sFileName, 'application/octet-stream');
            };
            setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
            return ajax;
        }
    }

    $('.wp-caption').each(function() {
       var $iMaxWidth = $(this).data('caption-max-width');
       $(this).css('max-width', $iMaxWidth + 'px');
    });

    $('.download_files .download_button').each(function() {
        var $sFirstItemPath = $(this).parent().siblings().children('.download_files_dropdown').val();
        $(this).data('download', $sFirstItemPath);
    });

    $('.download_files_dropdown').change(function() {
       var $sFilePath =  $(this).val();
       $(this).parent().siblings().children('.download_button').data('download', $sFilePath);
    });

    $('.download_button').click(function(event) {
        event.preventDefault();
        var $sFilePath = $(this).data('download');
        console.log('the file path is '+$sFilePath);
        download_file($sFilePath);
    });

    $('.rolling_number').each(function(index, value) {
        var $oElement = $(value);
        rollingNumberInView(index, $oElement);
    });

    function rollingNumberInView(index, value) {
        console.log('ran rolling number in view.');
        var oWaypoint = new Waypoint.Inview({
            element: $('.rolling_number')[index],
            entered: function() {
                if (value.hasClass('rolled') === false) {
                    rolling_number_handler(index, value);
                }
                value.addClass('rolled');
            }
        });
    }

    function rolling_number_handler(index, value) {
        value.prop('Counter', 0).animate({
            Counter: value.text()
        }, {
            duration: 3000,
            easing: 'swing',
            step: function (now) {
                value.text(Math.ceil(now));
            }
        });
    }

    // Init for responsive image maps
    $('img[usemap]').rwdImageMaps();

    // Make Instagram tile widget square
    if ($('.insta_pick').length > 0) {
        $('.insta_pick').height($('.insta_width').width());
    }

    // Allow linking to accordion answers
    const sPanelHash = $(location).attr('hash');
    if (sPanelHash.includes('panel')) {
        const oPanelParent = $(sPanelHash).parent();
        const aTag = $("a[href='" + sPanelHash + "']");
        $(sPanelHash).addClass('active');
        oPanelParent.addClass('active');
        oPanelParent.find('a').attr('aria-expanded', true);
        $('html,body').animate({scrollTop: aTag.offset().top},'slow');
    }

    // Listener for clopying to clipboard click
    const oCopyToClipboard = $('.wfu-copy-to-clipboard');
    oCopyToClipboard.click(function(e){
        e.preventDefault();
        const sAnswerURL = $(this).data('copy');
        copyToClipboard(sAnswerURL);
    });

    /**
     * Copy a string of text to the clipboard.
     *
     * @param sText
     *    The text to copy.
     *
     * @return void
     */
    function copyToClipboard(sText) {
        const oTempCopyElement = $("<input>");
        $("body").append(oTempCopyElement);
        oTempCopyElement.val(sText).select();
        document.execCommand("copy");
        oTempCopyElement.remove();
    }
});
